import { CustomComponent } from './components/custom/custom.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PersonasComponent } from './pages/personas/personas.component';
import { EmpresasComponent } from './pages/empresas/empresas.component';
import { BancaEnLineaComponent } from './components/banca-en-linea/banca-en-linea.component';
import { PaginaMantenimientoComponent } from './components/pagina-mantenimiento/pagina-mantenimiento.component';
import { MbaasComponent } from './pages/mbaas/mbaas.component';

const routes: Routes = [
  {
    path: '#/',
     redirectTo: 'personas'
    //redirectTo: 'pagina-mantenimiento'
  },
  {
    path: 'personas/:uuid',
     component: PersonasComponent
    //component: PaginaMantenimientoComponent
  },
  {
    path: 'pagina-mantenimiento',
    component: PaginaMantenimientoComponent
  },
  {
    path: 'personas',
     component: PersonasComponent
    //component: PaginaMantenimientoComponent
  },
  {
    path: 'empresas',
     component: EmpresasComponent
    //component: PaginaMantenimientoComponent
  },
  {
    path: 'empresas/:uuid',
     component: EmpresasComponent
    //component: PaginaMantenimientoComponent
  },
  {
    path: 'banca-en-linea',
     component: BancaEnLineaComponent
    //component: PaginaMantenimientoComponent
  },
  {
    path: 'mbaas',
     component: MbaasComponent
  },
  {
    path: 'mbaas/:uuid',
     component: MbaasComponent
  },
  {
    path: '**',
    pathMatch: 'full',
     redirectTo: 'personas'
    //redirectTo: 'pagina-mantenimiento'
},
{
  path: 'custom',
  component: CustomComponent
  //redirectTo: 'pagina-mantenimiento'
}
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{ useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
